import { FOLLOW_PROCESSING_END } from 'root/src/client/logic/creatorData/actionIds'

export default () => ({
	type: FOLLOW_PROCESSING_END,
})
